import HttpService from './HttpService';

const LocationsApi = HttpService('/api/locations/');
const doPost = (action, data) => LocationsApi.post(action, data);
const doGet = (url) => LocationsApi.get(url);
const doDelete = (url) => LocationsApi.delete(url);

export default {
  // locations for vessels
  getVesselLocations(activeSiteId) {
    const apiAction = 'GetVesselLocations';
    const queryString = `activeSiteId=${activeSiteId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  createLocation(location) {
    const apiAction = 'CreateLocation';
    return doPost(apiAction, location);
  },
  updateLocation(locationUpdate) {
    const apiAction = 'UpdateLocation';
    return doPost(apiAction, locationUpdate);
  },
  deleteLocation(id) {
    const apiAction = 'DeleteLocation';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
  getLocationTypes() {
    const apiAction = 'GetLocationTypes';
    return doGet(apiAction);
  },
};
